var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinDischarging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.652 80.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1300",
    "data-name": "Grupo 1300",
    transform: "translate(-220 -2412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_905",
    "data-name": "Caminho 905",
    stroke: "rgb(255 255 255 / 50%)",
    strokeWidth: 2,
    fill: "#616161",
    d: "M213.774,480.607a28.306,28.306,0,0,0-28.327,28.327c0,21.244,28.327,52.605,28.327,52.605S242.1,530.178,242.1,508.934A28.3,28.3,0,0,0,213.774,480.607Z",
    transform: "translate(34.553 1931.393)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1251",
    "data-name": "Grupo 1251",
    transform: "translate(227.339 2423.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_906",
    "data-name": "Caminho 906",
    d: "M231.406,506.346h-.167v-6.631a4.282,4.282,0,0,0-.154-1.188,4.027,4.027,0,0,0-3.966-2.917c-2.292-.008-4.581,0-6.873,0a1.19,1.19,0,0,0-.167.008,7.038,7.038,0,0,0-.218-1.191,3.69,3.69,0,0,0-1.924-2.764c-.1-.046-.186-.116-.285-.164-10.284-4.955-18.345-4.284-24.576-2.4a2.021,2.021,0,0,0-.859.5,7.113,7.113,0,0,0-1.954,3.8,12.209,12.209,0,0,0,.019,4.521,1.817,1.817,0,0,0,.531,1.182,33.037,33.037,0,0,0,4.33,3.33c-1.689.417-3.545.9-3.545.9a.628.628,0,0,0-.628.628v7.312l3.522,0a3.082,3.082,0,0,0-.045.609,3.14,3.14,0,0,0,6.278-.1,3.3,3.3,0,0,0-.059-.5c.491,0,.98,0,1.461,0a3.066,3.066,0,0,0-.045.595,3.147,3.147,0,1,0,6.24-.587c.751,0,7.6,0,13.088,0a3.14,3.14,0,1,0,6.239.49,3.057,3.057,0,0,0-.054-.488h4.276a1.416,1.416,0,0,0,.164-.024v-4.3A.628.628,0,0,0,231.406,506.346Z",
    transform: "translate(-190.062 -487.692)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDischarging);
export default __webpack_public_path__ + "static/media/pin-discharging.2a3bd5017d452043089210d3278c9450.svg";
export { ForwardRef as ReactComponent };